import CRUDService from "./base/CRUDService";

export default class ReadpointService extends CRUDService {

  static ALL_URL = "cloud/v1/readpoints/";

  getBaseURL() {
    return ReadpointService.ALL_URL;
  }

  saveReadEquipments(id, readpoint) {
    return super.getHttpRequest().put(`${this.getBaseURL()}${id}/read-equipments`, readpoint);
  }

  loadPortals() {
    return super.getHttpRequest().get(`${this.getBaseURL()}portals?size=100`)
  }

  async getReadPointById(readPointId) {
    return super.getHttpRequest().get(`${this.getBaseURL()}${readPointId}`);
  }

  assocUsersInReadpoint(readpointId, userIds) {
    return super.getHttpRequest().put(`${this.getBaseURL()}${readpointId}/assoc-users`, userIds)
  }

  async deleteReadPointById(readPointId) {
    return super.getHttpRequest().delete(`${this.getBaseURL()}${readPointId}`);
  }

}



// WEBPACK FOOTER //
// ./src/services/ReadpointService.js